require('./bootstrap');

// js extracted from old app.js
require('./state_manager.js');
require('./communication_log.js');
require('./comm_channels.js');
require('./appointment_modals.js');
require('../../../public/js/skipTrigger.jquery.js');
require('../../../public/js/mutuallyExclusive.jquery.js');

require('./vues/substudies.js');
require('./vues/consents.js');
require('./vues/participants.js');
require('./vues/colpo_review.js');
require('./vues/checks.js');
require('./vues/unassigned_substudies.js');
require('./vues/reports.js');
require('./vues/users.js');

// Initialize jquery plugins
$(document).ready(function() {
    $('[data-skiptarget]').skipTrigger();

    $('.closable').each(function () {
      var closeBtn = $('<button class="btn btn-link btn-xs close-button pull-right"><strong class="glyphicon glyphicon-remove"></strong></button>').on('click', function(evt){
        $(this).parent().fadeOut();
      })
      $(this).append(closeBtn);
    });

    // shim to force active styling on bootstrap radio/checkbox button groups.
    $('.btn-group .btn input[type=radio],input[type=checkbox]').on('change', function(){
        if ($(this).prop('checked')) {
          $(this).parents('label').addClass('active');
        }else{
          $(this).parents('label').removeClass('active');
        }
    });

    $('.sirs_datepicker').datepicker({
        format: "mm/dd/yyyy"
    });

    $('.sirs_timepicker').timepicker({
        minTime: '5:00am',
        maxTime: '7:00pm'
    }).on('keydown', function(evt){
      if([13,38,40].indexOf(evt.keyCode) < 0) {
        $(this).timepicker('hide');
      }
    }).on('changeTime', function(){
      $(this).removeClass('input-error');
    }).on('timeFormatError', function(){
      $(this).addClass('input-error');
    });
});